// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"9411e634","787":"76a1980c"}[chunkId] + ".chunk.js";
};